import { render, staticRenderFns } from "./SpaceConfigurationsPage.vue?vue&type=template&id=49fe0df0&scoped=true"
import script from "./SpaceConfigurationsPage.vue?vue&type=script&lang=ts"
export * from "./SpaceConfigurationsPage.vue?vue&type=script&lang=ts"
import style0 from "./SpaceConfigurationsPage.vue?vue&type=style&index=0&id=49fe0df0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fe0df0",
  null
  
)

export default component.exports